import React from "react";
import { Play } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { INTRO_VIDEO_URL } from "../data/content";
import { IMAGES } from "../data/content";

const isEmbed = (u) => /youtube|youtu\.be|vimeo/.test(u || "");

export const IntroVideo = () => (
  <section id="intro-video" className="relative overflow-hidden bg-white py-24 sm:py-32" data-testid="intro-video-section">
    <div className="mx-auto max-w-[1100px] px-5 text-center sm:px-8">
      <Reveal><div className="flex justify-center"><Overline>Watch the Introduction</Overline></div></Reveal>
      <Reveal delay={0.05}>
        <h2 className="mx-auto mt-6 max-w-2xl font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
          Meet <span className="text-gradient-emerald">OnwardTranscends</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-charcoal/65">
          A short introduction to how we help organisations and professionals strategise, optimise and transform.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 overflow-hidden rounded-[2rem] border border-black/5 bg-emerald-darkest card-shadow">
          {INTRO_VIDEO_URL && isEmbed(INTRO_VIDEO_URL) ? (
            <div className="relative aspect-video">
              <iframe title="OnwardTranscends introduction" src={INTRO_VIDEO_URL}
                className="absolute inset-0 h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          ) : INTRO_VIDEO_URL ? (
            <video controls poster={IMAGES.tech} className="aspect-video w-full" data-testid="intro-video-player">
              <source src={INTRO_VIDEO_URL} type="video/mp4" />
            </video>
          ) : (
            <div className="group relative flex aspect-video items-center justify-center" data-testid="intro-video-placeholder">
              <img src={IMAGES.tech} alt="Introduction video" className="absolute inset-0 h-full w-full object-cover opacity-40" />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-darkest via-emerald-darkest/50 to-transparent" />
              <div className="relative z-10 flex flex-col items-center">
                <span className="flex h-20 w-20 items-center justify-center rounded-full bg-gold text-emerald-darkest shadow-[0_10px_40px_rgba(212,175,55,0.5)] transition-transform duration-500 group-hover:scale-110">
                  <Play size={30} className="ml-1" fill="currentColor" />
                </span>
                <p className="mt-6 font-serif text-2xl text-off-white">Introductory video coming soon</p>
                <p className="mt-1 text-sm text-off-white/60">This space is reserved for Anthony's welcome video.</p>
              </div>
            </div>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);
